import { useEffect } from "react";
import confetti from "canvas-confetti";

const CelebrationAnimation = () => {
    const end = Date.now() + 1000; // 2 seconds

    const colors = ["#fe4e00", "#7fffd4", "#121212"];

    const frame = () => {
        confetti({
            particleCount: 3,
            angle: 60,
            spread: 55,
            origin: { x: 0 },
            colors: colors,
        });
        confetti({
            particleCount: 3,
            angle: 120,
            spread: 55,
            origin: { x: 1 },
            colors: colors,
        });

        if (Date.now() < end) {
            requestAnimationFrame(frame);
        }
    };

    useEffect(() => {
        frame();
    }, []);
};

export default CelebrationAnimation;
